import { OpenAPI } from '../../core/OpenAPI';
import { request } from '../../core/request';
import type { TAsrModelSettings } from './types';

export class AsrModelSettingsService {
  static getModelSettings() {
    return request<TAsrModelSettings[]>(OpenAPI, { method: 'GET', url: '/api/admin/asr-proxy/model-settings' });
  }

  static setModelNormalizers(modelName: string, enabledNormalizerNames: string[]) {
    return request<TAsrModelSettings>(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/asr-proxy/model-settings/{modelName}/normalizers',
      path: { modelName },
      body: { enabledNormalizerNames },
      mediaType: 'application/json',
    });
  }
  static setModelQualityCheckers(modelName: string, enabledQualityCheckerNames: string[]) {
    return request<TAsrModelSettings>(OpenAPI, {
      method: 'PUT',
      url: '/api/admin/asr-proxy/model-settings/{modelName}/quality-checkers',
      path: { modelName },
      body: { enabledQualityCheckerNames },
      mediaType: 'application/json',
    });
  }
}
